var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSellRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:register"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.7503 26.8334C23.6328 26.8334 13.417 29.3826 13.417 34.5001V38.3334H44.0837V34.5001C44.0837 29.3826 33.8678 26.8334 28.7503 26.8334ZM11.5003 19.1667V13.4167H7.66699V19.1667H1.91699V23.0001H7.66699V28.7501H11.5003V23.0001H17.2503V19.1667M28.7503 23.0001C30.7837 23.0001 32.7337 22.1923 34.1715 20.7546C35.6093 19.3168 36.417 17.3667 36.417 15.3334C36.417 13.3001 35.6093 11.35 34.1715 9.91226C32.7337 8.47448 30.7837 7.66675 28.7503 7.66675C26.717 7.66675 24.767 8.47448 23.3292 9.91226C21.8914 11.35 21.0837 13.3001 21.0837 15.3334C21.0837 17.3667 21.8914 19.3168 23.3292 20.7546C24.767 22.1923 26.717 23.0001 28.7503 23.0001Z",
    fill: "#FF5411"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSellRegister);
export default __webpack_public_path__ + "static/media/icon_sell_register.0b204c144298d2dda04bc1a6855758c0.svg";
export { ForwardRef as ReactComponent };